import { metricKeys } from '@pulse/metrics';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

const alertMetricsMapping = {
  EI: {
    [metricKeys.Attempts]: 'attempts',
    [metricKeys.ExitBeforeVideoStarts]: 'ebvs',
    [metricKeys.RebufferingRatio]: 'rr',
    [metricKeys.ConcurrentPlays]: 'pcv',
    [metricKeys.Bitrate]: 'abr',
    [metricKeys.VideoStartTime]: 'ast',
    [metricKeys.VideoRestartTime]: 'vrt',
    [metricKeys.ConnectionInducedRebufferingRatio]: 'nir',
    [metricKeys.EndedPlays]: 'ended plays',
    [metricKeys.VideoStartFailures]: 'vsf',
    [metricKeys.VideoPlaybackFailures]: 'vmf',
  },
  AI: {
    [metricKeys.ConcurrentPlays]: 'ads_concurrent_plays',
    [metricKeys.RebufferingRatio]: 'ads_rebuffering_ratio',
    [metricKeys.Bitrate]: 'ads_average_bitrate',
    [metricKeys.VideoStartTime]: 'ads_video_startup_time',
    [metricKeys.Attempts]: 'ad_attempts',
    [metricKeys.VideoStartFailures]: 'ad_start_failures',
    [metricKeys.ExitBeforeVideoStarts]: 'exits_before_ad_start',
    [metricKeys.VideoPlaybackFailures]: 'ad_playback_failures',
    [metricKeys.AdSlateDurationPct]: 'slates_duration',
    [metricKeys.AdSlatePlaysPct]: 'slates_started',
  },
  APP: {},
};

const alertTechErrorMetrics = {
  [metricKeys.VideoStartFailuresTech]: 'vsf_technical',
  [metricKeys.VideoPlaybackFailuresTech]: 'vpf_technical',
  [metricKeys.VideoStartFailuresBusiness]: 'vsf_business',
  [metricKeys.VideoPlaybackFailuresBusiness]: 'vpf_business',
};

export const METRIC_TO_ALERT_METRIC_MAPPING = (bleEnabled) => {
  if (CURRENT_PRODUCT_MODE === 'EI' && bleEnabled) {
    return { ...alertMetricsMapping[CURRENT_PRODUCT_MODE], ...alertTechErrorMetrics };
  }
  return alertMetricsMapping[CURRENT_PRODUCT_MODE];
};
